// EN-799: arc math for score-circle.vue's "locked" segment — the portion of
// the ring representing points that can't be earned yet (e.g. the 40
// Alignment points while alignment_status is locked), rendered as a
// dashed arc spanning [maxTotal%, 100%] of the circle rather than plain
// background, so it reads as "locked", not just "not yet earned".
//
// Derivation: a circle's stroke-dasharray/dashoffset trick draws a visible
// arc of `dashLength` starting at path-position 0 when dashoffset is 0. A
// two-value dasharray [D, L-D] (D = desired arc length, L = circumference)
// with dashoffset = D shifts that same dash so it instead starts at
// path-position (L-D) and runs to L — i.e., exactly the arc from
// `maxTotal%` to `100%`, since D here is chosen as the *locked* segment's
// length (100 - maxTotal)% of the circumference.
export const computeLockedArc = (circumference, maxTotal) => {
	const lockedLength = circumference * ((100 - maxTotal) / 100);

	return {
		length: lockedLength,
		dashArray: `${lockedLength} ${circumference - lockedLength}`,
		dashOffset: lockedLength,
	};
};
